// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3xz-F","large":"styles_large__jm95h"};